import { render, staticRenderFns } from "./FlameGraph.vue?vue&type=template&id=5b2020b8&scoped=true"
import script from "./FlameGraph.vue?vue&type=script&lang=js"
export * from "./FlameGraph.vue?vue&type=script&lang=js"
import style0 from "./FlameGraph.vue?vue&type=style&index=0&id=5b2020b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2020b8",
  null
  
)

export default component.exports